import { Factory } from 'miragejs';

export default Factory.extend({
  features: () => ['dynamic_company_creation_de'],
  createdAt: '2024-04-11T13:46:48.064414Z',
});
